import React from "react";
import { Button, Offcanvas } from "react-bootstrap";

export default function EventTicketsSlider({ item }) {
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div >
      {item.Tickets?.length > 0 ? (
        <Button variant="" className="p-0 " onClick={handleShow}>
          <span >
            <span className="badge bg-secondary mb-2">{item.Tickets?.[0]}</span>
            {item.Tickets?.length > 1
              ? ` and ${item.Tickets?.length - 1} more`
              : null}
          </span>
        </Button>
      ) : null}

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Event Tickets</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <p>List of tickets related to this event will be shown here.</p>
          <ul>
            {item.Tickets && item.Tickets.length > 0 ? (
              item.Tickets.map((ticket, index) => (
                <li key={index}>
                  <span className="badge bg-secondary">{ticket}</span>
                </li>
              ))
            ) : (
              <li>No tickets available for this event.</li>
            )}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}
